/**
 * Foto del cliente sin foto: iniciales sobre un degradé fijo por conversación. Archivo liviano (sin
 * React ni estilos) para que la campanita del menú lo use sin cargar Conversaciones.
 */

/* Degradés de la maqueta (rosa, índigo, ámbar, verde, violeta): fijos por conversación. */
const GRADIENTS = [
  'linear-gradient(135deg,#F9A8D4,#DB2777)',
  'linear-gradient(135deg,#A5B4FC,#4F46E5)',
  'linear-gradient(135deg,#FCD34D,#D97706)',
  'linear-gradient(135deg,#6EE7B7,#059669)',
  'linear-gradient(135deg,#C4B5FD,#7C3AED)',
  'linear-gradient(135deg,#FDA4AF,#E11D48)'
];

export const gradientFor = (id: number) => GRADIENTS[Math.abs(id - 1) % GRADIENTS.length];

/** «Sofía Paz» → «SP»; con `full` false (nombre de perfil de WhatsApp), sólo la primera letra. */
export const nameInitials = (name: string | null | undefined, full = true): string => {
  const parts = (name ?? '')
    .trim()
    .split(/\s+/)
    .filter((p) => /\p{L}/u.test(p));
  if (!parts.length) return '?';
  return (parts[0][0] + (full && parts[1] ? parts[1][0] : '')).toUpperCase();
};
